import React from 'react';
import { Text } from '@mantine/core';
import { EssayNode } from '../../hooks/useEssayApi';
import classes from './EssayPreview.module.css';

/** Убирает пустые пункты, поднимая их заполненных детей на своё место. */
export function pruneNodes(nodes: EssayNode[]): EssayNode[] {
  return (nodes || []).flatMap((node) => {
    const children = pruneNodes(node.children || []);
    return node.text.trim() ? [{ ...node, children }] : children;
  });
}

/**
 * Дерево пунктов в том виде, в каком оно уедет в отчёт: нумерованными списками,
 * а не полями ввода.
 *
 * Отдельно от `EssayPreview`, потому что тот знает про четыре раздела эссе, а
 * дерево пунктов само по себе про разделы ничего не знает — его же показывает и
 * квартальный отчёт, где раздел один.
 */
export const NodeListPreview: React.FC<{ nodes: EssayNode[] }> = ({ nodes }) => (
  <ol className={classes.list}>
    {nodes.map((node) => (
      <li key={node.id} className={classes.item}>
        <span className={classes.marker} aria-hidden />
        <div style={{ flex: 1 }}>
          <Text size="sm" className={classes.text}>
            {node.text}
          </Text>
          {node.children.length > 0 && <NodeListPreview nodes={node.children} />}
        </div>
      </li>
    ))}
  </ol>
);
